module.exports = __webpack_public_path__ + "img/half_result_header.ab0473b4.png";